import React from 'react';
import { Box } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import {
    Grid,
    GridRow,
    GridCol,
    Alert,
    AlertVariant,
    Typography,
    Variant
} from '../../styles';

export const AnnuleeConseiller: React.FC<unknown> = () => {
    const [t] = useTranslation(['AnnuleeConseiller']);

    const renderAnnuleeConseillerHeader = () => (
        <>
            <Typography variant={Variant.h1}>{t('title')}</Typography>
        </>
    );
    const renderAnnuleeConseillerAlert = () => {
        return (
            <Box pb={1} data-testid="erreur_annulee_conseiller">
                <Alert variant={AlertVariant.confirmation}>
                    {t('annuleeConseillerText')}
                </Alert>
            </Box>
        );
    };
    return (
        <>
            <Grid>
                <GridRow>
                    {/* Header title */}
                    <GridCol col="12" sm="12">
                        {renderAnnuleeConseillerHeader()}
                    </GridCol>
                    {/* Alert */}
                    <GridCol col="12" sm="12">
                        {renderAnnuleeConseillerAlert()}
                    </GridCol>
                </GridRow>
            </Grid>
        </>
    );
};
